import React from 'react';
import { Button } from 'nike-ui/src/components/button/Button';
import i18n from '@i18n';
import ChatIcon from 'nike-ui/src/icons/svg/chat-icon-sv.svg';
import { CHAT_NEW_MESSAGE } from '@/routing/routes';
import { navigate } from '@/routing';
import { fireGAEvent } from '@/analytics';
import { CURRENT_PAGE } from 'nike-ui/src/common/routing';

export const AddToChat = ({ ticket }) => {
    const goToChatMessageEditor = () => {
        const isSavedTicket = ticket?.source === 'Saved';
        const trackActionPart = isSavedTicket ? 'ulozeny' : 'podany';
        fireGAEvent(CURRENT_PAGE, `Pridat ${trackActionPart} tiket do chatu`);
        navigate(CHAT_NEW_MESSAGE, {}, { ticketHash: ticket.hash });
    };

    return (
        <Button
            className="blue"
            dataAtid="ticket-detail-add-to-chat"
            icon={ChatIcon}
            label={i18n('markdown.analysis.share.btn')}
            onClick={goToChatMessageEditor}
        />
    );
};
